import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { FelderServiceModule } from '..';
import { FelderFilterComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    FelderServiceModule
  ],
  declarations: [FelderFilterComponent],
  exports: [FelderFilterComponent],

})
export class FelderFilterComponentModule { }
